<template>
  <VueFinalModal
    content-class="modal-content"
    :classes="['modal-container', ...classes]"
    :click-to-close="clickToClose"
    :lock-scroll="lockScroll"
    :min-width="minWidth"
    :min-height="minHeight"
    :max-width="maxWidth"
    :max-height="maxHeight"
    :hide-overlay="hideOverlay"
    :name="name"
    :z-index-base="2000"
    @click-outside="clickOutside"
    @before-open="beforeOpen"
    @opened="opened"
    @before-close="beforeClose"
    @closed="closed"
  >
    <slot></slot>
  </VueFinalModal>
</template>

<script lang="ts" setup>
defineProps({
  name: { type: String, default: null },
  hideOverlay: { type: Boolean, default: true },
  classes: { type: [Array], default: () => [] }, // use props => classes: ['modal-bg-transparent'] if you need transparent background for .modal-content
  lockScroll: { type: Boolean, default: false },
  clickToClose: { type: Boolean, default: true },
  minWidth: { type: Number, default: 100 },
  minHeight: { type: Number, default: 100 },
  maxWidth: { type: Number, default: 100 },
  maxHeight: { type: Number, default: 100 },
  clickOutside: { type: Function, default: () => ({}) },
  beforeOpen: { type: Function, default: () => ({}) },
  opened: { type: Function, default: () => ({}) },
  beforeClose: { type: Function, default: () => ({}) },
  closed: { type: Function, default: () => ({}) },
});
</script>
